import { Directive } from '@angular/core';

import './VbUiTextInput.Directive.less';

/**
 * Applies our standard text input styling to a native text input element.
 */
@Directive({
	selector: '[vbUiTextInput]',
	host: {
		'class': 'TextInput TextInputFocusBorder theme-accent-border-focus vb-scrollbar'
	}
})
export class VbUiTextInputDirective { }
